import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// report-common
import { getReportSelectors } from '../../report-common';
//////////////////////////////////////////////////

const {
  store,
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
} = getReportSelectors('serviceVendor');

// service vendor
const makeSelectServiceVendor = () => createSelector(
  store,
  ({ profile }) => R.assoc(
    GC.FIELD_SERVICE_TYPES,
    R.map(
      R.prop(GC.FIELD_DROPDOWN_OPTION_GUID),
      R.pathOr([], [GC.FIELD_SERVICE_TYPES], profile),
    ),
    profile,
  ),
);

const makeSelectServiceVendorGuid = () => createSelector(
  store,
  ({ profile }) => G.getGuidFromObject(profile),
);

const makeSelectServiceVendorBranchGuid = () => createSelector(
  store,
  ({ profile }) => G.getBranchGuidFromObject(profile),
);

const makeSelectCollapsedGroup = () => createSelector(
  store,
  ({ collapsedGroup }) => collapsedGroup,
);

const makeSelectSelectedList = () => createSelector(
  store,
  R.compose(
    R.keys,
    R.filter(({ selected }) => selected),
    R.pathOr([], ['itemList']),
  ),
);

const makeSelectIntegrationInfoList = () => createSelector(
  store,
  ({ integrationInfoList }) => integrationInfoList,
);

const makeSelectIntegrationAuditList = () => createSelector(
  store,
  ({ integrationAuditList }) => integrationAuditList,
);

const makeSelectDocumentList = () => createSelector(
  store,
  ({ documentList, documentsFilter }) => {
    if (G.isAnyNilOrEmpty([documentList, documentsFilter])) return documentList;

    return R.filter(
      ({ documentType }) => R.propEq(documentsFilter, GC.FIELD_DROPDOWN_OPTION_GUID, documentType),
      documentList,
    );
  },
);

const makeSelectGeofencingZoneList = () => createSelector(
  store,
  ({ geofencingZoneList }) => R.compose(
    R.sortBy(R.prop('index')),
    R.map(({ addressPoints, ...item }) => ({
      ...item,
      disabled: false,
      zoneAddressPoints: addressPoints,
    })),
    R.values,
  )(geofencingZoneList),
);

const makeSelectUserGeneralList = () => createSelector(
  store,
  ({ userGeneralList }) => userGeneralList,
);

const makeSelectDocumentsFilter = () => createSelector(
  store,
  ({ documentsFilter }) => documentsFilter,
);
// service vendor

// configs
const makeSelectServiceVendorConfigs = () => createSelector(
  store,
  ({ configs }) => configs,
);
// configs

export {
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectTotalCount,
  makeSelectPagination,
  makeSelectPageVisited,
  makeSelectListLoading,
  makeSelectDocumentList,
  makeSelectReportStatus,
  makeSelectSelectedList,
  makeSelectServiceVendor,
  makeSelectCollapsedGroup,
  makeSelectDocumentsFilter,
  makeSelectUserGeneralList,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
  makeSelectServiceVendorGuid,
  makeSelectGeofencingZoneList,
  makeSelectIntegrationInfoList,
  makeSelectServiceVendorConfigs,
  makeSelectIntegrationAuditList,
  makeSelectServiceVendorBranchGuid,
};
